<!-- 资料变更数据操作 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog  :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" center append-to-body top="2rem"  width="60%" >
			<el-form  label-width="150px"  size="mini" label-position="top">
				<el-form-item label="变更类型" >
					<el-radio-group v-model="sendDataInfo.gchmType">
					    <el-radio-button v-for="(values,keys) in $store.state.dataChangeType" :label="values.id" :key="keys">{{values.name}}</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="变更内容" >
					<el-input type="textarea" v-model="sendDataInfo.gchmContent" maxlength="300" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="dataActionBox.showStatus = false">取 消</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
				<el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
			</span>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'dataChangeAction',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				boxTitle:'新增信息'||'编辑信息',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
				"gchmContent": "",
				"gchmType": 0
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
		
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key] = ""
		
			}
			this.sendDataInfo.gchmType = 0;
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		
		
		
		
		openBox(cate,formDataList,oldData=''){
			console.log(oldData)
			this.initActionBox()
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增资料变更信息'
			}else{
				this.dataActionBox.boxTitle = '编辑资料变更信息'
				var dataInfo = JSON.parse(JSON.stringify(oldData))
				this.sendDataInfo = dataInfo
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		
		async sendDataAction(){
		
			if(this.sendDataInfo.gchmContent ==''){
				this.$message({
					message: '请输入变更内容',
					type: 'error'
				});
				return false
			}
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.addDataChange(sendData)
			}else{
				var responseData =  await this.$http.setDataChange(sendData)
			}
			if(responseData.status == 200){
				this.initActionBox()
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				if(this.dataActionBox.actionType==0){
					this.$parent.setDataPageNumber(1)
				}else{
					this.$parent.getDataList()
				}
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>